/* eslint-disable */
import Store from 'react-native-simple-store'

let store
Store.get('store').then((stored) => {
  store = stored || {}
})

export default {
  get(key) {
    return store[key]
  },
  
  async ready() {
    return new Promise(resolve => {
      const interval = setInterval(() => {
        if (store) {
          resolve()
          clearInterval(interval)
        }
      })
    })
  },
  
  async fallback(key, promise) {
    if (store[key] != undefined) {
      promise.then((value) => {
        this.set(key, value)
      })
      
      return store[key]
    }
    
    return promise.then((value) => {
      this.set(key, value)
      return value
    })
  },
  
  set(key, value, lastModified) {
    store[key] = value
    store[`${key}@lastModified`] = lastModified || Date.now()
    Store.save('store', store)
  },
  
  lastModified(key) {
    return store[`${key}@lastModified`]
  },
}